"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _base = _interopRequireDefault(require("./base"));

var _verticalformbase = _interopRequireDefault(require("./verticalformbase"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var FormWrapper = function FormWrapper(_ref) {
  var _ref$formLayout = _ref.formLayout,
      formLayout = _ref$formLayout === void 0 ? 'horizontal' : _ref$formLayout,
      _ref$Control = _ref.Control,
      Control = _ref$Control === void 0 ? null : _ref$Control,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["formLayout", "Control"]);

  if (formLayout === 'vertical') {
    return /*#__PURE__*/_react["default"].createElement(_verticalformbase["default"], (0, _extends2["default"])({
      Control: Control
    }, props));
  } else {
    return /*#__PURE__*/_react["default"].createElement(_base["default"], (0, _extends2["default"])({
      Control: Control
    }, props));
  }
};

FormWrapper.propTypes = {
  formLayout: _propTypes["default"].string,
  Control: _propTypes["default"].any
};
var _default = FormWrapper;
exports["default"] = _default;
//# sourceMappingURL=FormBaseWrapper.js.map